import { InjectionToken } from '@angular/core';
import { type IStaffer } from '@principle-theorem/principle-core/interfaces';
import { type WithRef } from '@principle-theorem/shared';
import { type Observable } from 'rxjs';

export interface IChartingAsProvider {
  chartingAsInAppointment$(): Observable<WithRef<IStaffer> | undefined>;
}

export const CHARTING_AS_PROVIDER = new InjectionToken<IChartingAsProvider>(
  'CHARTING_AS_PROVIDER'
);
